// context/MapSyncContext.tsx
import React, { createContext, useContext, useState } from "react";

type MapSyncContextType = {
  mapCenter: [number, number];
  setMapCenter: (center: [number, number]) => void;
  mapZoom: number;
  setMapZoom: (zoom: number) => void;
};

const MapSyncContext = createContext<MapSyncContextType | undefined>(undefined);

export const MapSyncProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mapCenter, setMapCenter] = useState<[number, number]>([38.56317, -121.73036]);
  const [mapZoom, setMapZoom] = useState<number>(7);

  return (
    <MapSyncContext.Provider value={{ mapCenter, setMapCenter, mapZoom, setMapZoom }}>
      {children}
    </MapSyncContext.Provider>
  );
};

export const useMapSync = (): MapSyncContextType => {
  const context = useContext(MapSyncContext);
  if (!context) throw new Error("useMapSync must be used within a MapSyncProvider");
  return context;
};

export {};